export default {
    'modify-details': 'تفاصيل التعديل',
    'contact-information': 'معلومات التواصل',
    'addresses': 'العناوين',
    'modification-reason': 'سبب التعديل',
    'confirm-acceptance': 'تأكيد القبول',
    'confirm-rejection': 'تأكيد الرفض',
    'this-request': 'هذا الطلب',
    'requests-type': 'أنواع الطلبات',
    'view-modify-details': 'عرض تفاصيل التعديل',
    'accept-request': 'قبول الطلب',
    'reject-request': 'رفض الطلب',
    'request-reason': 'السبب',
    'requested-by': 'مرسلة من قِبل',
    'request-type': 'نوع الطلب',
    'the-request-is-accepted': 'تم قبول الطلب',
    'the-request-is-reject': 'تم رفض الطلب',
    'disable-customer': 'إلغاء تفعيل زبون',
    'are-you-sure-you-want-to-deactivate-this-client': 'هل أنت متأكد من أنك تريد إلغاء تفعيل هذا الزبون',
    'delete-customer': 'حذف الزبون',
    'deactivate-customer': 'إلغاء تفعيل الزبون',
    'modification': 'التعديل',
    'creation': 'الإضافة',
    'deletion': 'الحذف'
}